export const getDevice = function (c) {
  let devices = [];
  if (c.mobile) devices.push("Mobile");
  if (c.pc) devices.push("PC");
  return devices;
};

export const getExternalUrl = function (item) {
  return (
    process.env.VUE_APP_EXTERNAL_DOMAIN +
    "/read.php?u=" +
    item.team.code +
    "&k=" +
    item.external_key
  );
};
